import React from 'react';
import { Box } from '@mui/material';
import { participantColors as c } from '../../theme/participantTheme';

interface BottomSheetProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  maxHeight?: string;
}

const sheetUpKeyframes = `
@keyframes participantSheetUp {
  0% { transform: translateY(40px); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
}
`;

/**
 * Bottom-sheet modal compartilhado do fluxo do participante — usado pra
 * modais de informação (regulamento/lojas/patrocinadores) e confirmações
 * (ex: excluir cupom).
 */
export const BottomSheet: React.FC<BottomSheetProps> = ({ open, onClose, children, maxHeight = '82vh' }) => {
  if (!open) return null;

  return (
    <Box
      onClick={onClose}
      sx={{
        position: 'fixed',
        inset: 0,
        background: c.scrim,
        zIndex: 1300,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
      }}
    >
      <style>{sheetUpKeyframes}</style>
      <Box
        onClick={(e: React.MouseEvent) => e.stopPropagation()}
        sx={{
          width: '100%',
          maxWidth: 620,
          maxHeight,
          background: c.surface,
          borderRadius: c.radius.sheetTop,
          animation: 'participantSheetUp 0.25s ease both',
          display: 'flex',
          flexDirection: 'column',
          fontFamily: c.fontFamily,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
